export const COUNTRY_NAME = {
  ENGLAND: "ENGLAND",
  UNITED_KINGDOM: "UNITED KINGDOM",
  GREAT_BRITAIN: "GREAT BRITAIN",
  IRELAND: "IRELAND",
  REPUBLIC_OF_IRELAND: "REPUBLIC OF IRELAND",
};
